import { Hint, LocaleEnum } from '@systemeio/ui'
import FormSenderEmailInput from 'modules/email/components/form-sender-email-input'
import TransLoco from 'shared/components/trans-loco'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import useUser from 'shared/hooks/use-user'
import { useSubstituteEmails } from '../hooks/use-substitute-emails'

const getHelpArticleLink = (locale?: LocaleEnum) => {
  switch (locale) {
    case LocaleEnum.DUTCH:
      return 'https://help-nl.systeme.io/article/1394-is-het-mogelijk-om-een-prive-e-mailadres-te-gebruiken-om-e-mails-te-verzenden-vanuit-systeme-io'
    case LocaleEnum.DEUTSCH:
      return 'https://help-de.systeme.io/article/1766-ist-es-moglich-eine-private-e-mail-adresse-zu-verwenden-um-e-mails-von-systemeio-zu-versenden'
    case LocaleEnum.PORTUGUESE:
      return 'https://help-pt.systeme.io/article/743-e-possivel-usar-um-endereco-de-email-particular-para-enviar-emails-na-systeme-io'
    case LocaleEnum.ITALIAN:
      return 'https://help-it.systeme.io/article/478-non-posso-usare-un-indirizzo-yahoo-per-inviare-le-mie-e-mail'
    case LocaleEnum.JAPANESE:
      return 'https://help-jp.systeme.io/article/2410-is-it-possible-to-use-a-private-email-address-to-send-emails-from-systemeio'
    case LocaleEnum.CHINESE:
      return 'https://help-zh.systeme.io/article/3218-is-it-possible-to-use-a-private-email-address-to-send-emails-from-systeme-io'
    case LocaleEnum.ARABIC:
      return 'https://help-ar.systeme.io/article/2731-is-its-possible-to-use-private-email-address-to-send-emails-from-systeme-io'
    case LocaleEnum.FRENCH:
      return 'https://aide.systeme.io/article/29-est-il-possible-utiliser-une-adresse-email-personnelle-pour-envoyer-des-emails-sur-systemeio'
    case LocaleEnum.SPANISH:
      return 'https://help-es.systeme.io/article/878-no-puedo-usar-una-direccion-de-correo-electronico-de-gmail-yahoo-para-enviar-mis-correos-electronicos'
    case LocaleEnum.HINDI:
      return 'https://help-hi.systeme.io/article/3264-is-it-possible-to-use-a-private-email-address-to-send-emails-from-systeme-io'
    default: 
      return 'https://help.systeme.io/article/272-is-it-possible-to-use-a-private-email-address-to-send-emails-from-systemeio'
      
  }
}

namespace SenderEmailInput {
  export interface Props {
    value: string
    onChange: (value: string) => void
    error?: string
    disabled?: boolean
  }
}

export function SenderEmailInput({ value, onChange, error, disabled }: SenderEmailInput.Props) {
  const { t } = useLocoTranslation()
  const { user } = useUser()
  const { substituteEmails } = useSubstituteEmails()
  const userAccountEmail = user?.mainUser?.user.email || ''
  const substituteEmail = value ? substituteEmails?.[value] : substituteEmails?.[userAccountEmail]
  return (
    <FormSenderEmailInput
      descriptionClassName={'text-text-primary opacity-100'}
      description={
        substituteEmail ? (
            <TransLoco
              t={t}
              i18nKey={'dashboard.settings.mailing.sender_email.description'}
              values={{
                substituteEmail: substituteEmail,
              }}
              components={{
                a: (
                  <a
                    href={getHelpArticleLink(user?.dashboardLocale)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="primary-link"
                  />
                ),
                b: <span className={'text-brand-primary'}/>,
              }}
            />
        ) : undefined
      }
      labelClassName={'text-text-primary'}
      placeholder={userAccountEmail}
      label={
        <Hint label={t('dashboard.settings.mailing.sender_email_address_popover_title')}>
          {t('dashboard.settings.mailing.sender_email_address_title')}
        </Hint>
      }
      value={value}
      onChange={e => onChange(e.target.value)}
      error={error}
      disabled={disabled}
    />
  )
}
